import React from 'react';

export default class SecurityCheckForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      username: '',
      password: ''
    }
  }
  isPassSecurityCheck(e) {
    if (this.state.username != '' && this.state.password != '') {
      this.props.passedSecurityCheck(this.state.username, this.state.password);
    };
    e.preventDefault();
  }
  handleUsernameInput(textInput) {
    this.setState({ username: textInput });
  }
  handlePasswordInput(textInput) {
    this.setState({ password: textInput });
  }
  render() {
    return (
      <React.Fragment>
        <div className="security-check-container">
          <form className="fields-container">
            <div className="input-field-container">
              <div className="field-header">UserName</div>
              <input className="field-input" value={this.state.username} onChange={(evt) => this.handleUsernameInput(evt.target.value)} type="text"></input>
            </div>
            <div className="input-field-container">
              <div className="field-header">Password</div>
              <input className="field-input" value={this.state.password} onChange={(evt) => this.handlePasswordInput(evt.target.value)} type="password"></input>
            </div>
            <div className="security-check-verify-button"><button onClick={(e) => this.isPassSecurityCheck(e)}>Verify</button></div>
          </form>
        </div>
      </React.Fragment>
    );
  }

};
